import type {
  MarkerLaneMarkers,
  MarkerLanes,
  Segment,
} from '@iconik-io/unified-player-core';

import type { MarkerLaneConfigMap } from '../types.js';

const createMarkersFromSegments = (segments: Segment[]): MarkerLaneMarkers => {
  const markers: MarkerLaneMarkers = {};

  segments.forEach((segment) => {
    const segmentStartTime = segment.range?.start;
    if (segmentStartTime === undefined) {
      return;
    }
    if (!markers[segmentStartTime]) {
      markers[segmentStartTime] = {
        id: `marker-${segmentStartTime}`,
        segments: [segment],
      };
    } else {
      markers[segmentStartTime].segments.push(segment);
    }
  });

  return markers;
};

export const createMarkerLanes = (
  segments: Segment[],
  configMap: MarkerLaneConfigMap,
): MarkerLanes => {
  const markerLanes: MarkerLanes = {};

  // If there are no marker lanes set up, consider them all primary
  if (!Object.keys(configMap).length) {
    markerLanes.primary = { markers: createMarkersFromSegments(segments) };
    return markerLanes;
  }

  // Set up primary lane
  const primaryLanes = Object.entries(configMap)
    .filter(([, options]) => options.primary)
    .map(([name]) => name);

  markerLanes.primary = {
    markers: createMarkersFromSegments(
      segments.filter((segment) => primaryLanes.includes(segment.type)),
    ),
  };

  // Set up individual lanes
  Object.entries(configMap).forEach(([name, options]) => {
    if (options.primary) {
      return;
    }
    const laneSegments = segments.filter((segment) => segment.type === name);
    if (laneSegments.length === 0) {
      return;
    }
    markerLanes[name] = {
      icon: options.icon,
      color: options.color,
      markers: createMarkersFromSegments(laneSegments),
    };
  });

  return markerLanes;
};
